import { UNLABELLED_ASSET_LABEL, INDEX_FALLBACK } from "@overmap-ai/common"
import type { IFuseOptions } from "fuse.js"

import type { AssetAndIdentifiers } from "../typings"

export const ASSET_FUSE_OPTIONS: IFuseOptions<AssetAndIdentifiers> = {
	isCaseSensitive: false,
	threshold: 0.2,
	keys: [
		{
			name: "index",
			weight: 0.5,
			getFn: ({ asset }) => asset.index?.toString() ?? INDEX_FALLBACK,
		},
		{
			name: "label",
			weight: 0.5,
			getFn: ({ asset }) => asset.label || UNLABELLED_ASSET_LABEL,
		},
		{
			name: "identifiers",
			weight: 2,
			getFn: ({ identifierValues }) => identifierValues.map(({ value }) => value),
		},
	],
}
